export class ParamsSpedizioneLotto
{
  idLottoSpedizione: number;
  corriere: string;
  trackingId: string;
  recVer: number;

  constructor() {
      this.idLottoSpedizione = null;
      this.corriere = null;
      this.trackingId = null;
      this.recVer = 0;
  }

}


// WEBPACK FOOTER //
// ./src/app/_models/params-spedizione-lotto.ts